export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Card"] = "card";
    PaymentMethod["Ach"] = "ach";
    PaymentMethod["Check"] = "check";
    PaymentMethod["eCheck"] = "eCheck";
    PaymentMethod["Eft"] = "eft";
})(PaymentMethod || (PaymentMethod = {}));
const premiumFinance = 'premiumFinance';
export const hppPaymentMethods = [PaymentMethod.Ach, PaymentMethod.Card, PaymentMethod.Eft, premiumFinance];
export const autoPaymentMethods = [PaymentMethod.Ach, PaymentMethod.Card];
//# sourceMappingURL=PaymentMethod.js.map